import React from "react";
import styles from "./Fabs.module.css";
import Fab from "@material-ui/core/Fab";
import Tooltip from "@material-ui/core/Tooltip";
import SmsIcon from "@material-ui/icons/Sms";
import PhoneIcon from "@material-ui/icons/Phone";

function Fabs(props) {
  return (
    <div className={styles.container}>
      <div className={styles.fab_item}>
        <a href={`${process.env.REACT_APP_ADMIN_MESSENGER}`} target="_blank" rel="nofollow">
          <Tooltip title="Nhắn tin với chúng tôi" aria-label="add">
            <Fab color="primary" aria-label="add" size="small">
              <SmsIcon />
            </Fab>
          </Tooltip>
        </a>
      </div>
      <div className={styles.item}>
        <a href={`tel:${process.env.REACT_APP_ADMIN_PHONE}`}>
          <Tooltip title="Liên hệ với chúng tôi" aria-label="add">
            <Fab color="primary" aria-label="add" size="small">
              <PhoneIcon />
            </Fab>
          </Tooltip>
        </a>
      </div>
    </div>
  );
}

Fabs.propTypes = {};

export default Fabs;
